import { SpecialFieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { getSelectedFormItemReference as _getSelectedFormItemReference, getSelectedFormItemType as _getSelectedFormItemType
// @ts-expect-error untyped dependency
} from 'FormsCommonComponents/selectors/FormSelection';
import { getFormFieldsByPropertyId, getRichText
// @ts-expect-error untyped dependency
} from 'FormsUI/selectors/FormDefinition';
import { SELECTED_FROM_SOURCES, getSelectedFormItemSource } from 'FormsUI/utils/FormSelectionUtils';
export const getSelectedFormItemTypeFromFormDefinition = state => {
  const formItemReference = _getSelectedFormItemReference(state);
  const selectedFormItemType = _getSelectedFormItemType(state);
  const formFieldsByPropertyId = getFormFieldsByPropertyId(state);
  const formField = formFieldsByPropertyId[formItemReference];
  const richText = getRichText(state, formItemReference);
  const selectedFrom = getSelectedFormItemSource({
    formItemReference,
    selectedFormItemType,
    formField,
    richText
  });
  switch (selectedFrom) {
    case SELECTED_FROM_SOURCES.NONE:
      return undefined;
    case SELECTED_FROM_SOURCES.FORM_FIELD:
      return formField.fieldType;
    case SELECTED_FROM_SOURCES.RICH_TEXT:
      return SpecialFieldTypes.RICH_TEXT;
    case SELECTED_FROM_SOURCES.IMAGE:
      return SpecialFieldTypes.IMAGE;
    case SELECTED_FROM_SOURCES.SELECTED:
    default:
      return selectedFormItemType;
  }
};
export const getSelectedFormItemReference = state => _getSelectedFormItemReference(state);
export const getSelectedFormItemType = state => getSelectedFormItemTypeFromFormDefinition(state);